import { z } from 'zod';

// Payload schema for the `order_updated` WS action (NOT the wire message —
// the WS layer owns and strips `action`). Slim notify-and-refetch contract:
// the server never pushes the order document (large orders approach the API
// Gateway 128KB frame limit); clients with an older cached version refetch
// the order via GET.
export const orderUpdatedPayloadSchema = z.object({
  order_id: z.string(),
  version: z.number(),
});

export type OrderUpdatedPayload = z.infer<typeof orderUpdatedPayloadSchema>;
